module.exports = __webpack_public_path__ + "img/content6-9.66479f7e.webp";